import React, { useState, useRef, useEffect } from 'react';
// , { useState }
import { Layout } from 'antd';
// , Badge, Space
import matrimonyLogo from '@/common/assets/images/LogoHeaer.png';
import SearchIcon from '@/common/assets/images/searchIcon.png';
import HomeIcon from '@/common/assets/images/home.svg';
import HelpCenterIcon from '@/common/assets/images/helpcenter.svg';
import FeedbackIcon from '@/common/assets/images/feedback.svg';
// import NotificationIcon from '@/common/assets/images/Notification.svg';
import UserIcon from '@/common/assets/images/userIcon.png';
import { useNavigate, Link } from 'react-router-dom';
// import Twitter from '@/common/assets/images/X.svg';
// import Linkedin from '@/common/assets/images/Linkedin.svg';
import Facebook from '@/common/assets/images/fb.svg';
import Instagram from '@/common/assets/images/Insta.svg';
import { useDispatch, useSelector } from 'react-redux';
import { logout } from 'pages/login/redux/slice';
// , get_notifications
import { get_byID, get_Payment_ID } from 'pages/ListView/redux/slice';
import { useLocation } from 'react-router-dom';
// , Menu, Input, Button, Avatar, Dropdown
import ManageProfile from '@/common/assets/images/ManageProfile.svg';
import ManageSettings from '@/common/assets/images/ManageSettings.svg';
import logoutIcon from '@/common/assets/images/Logout.svg';
import ManageProfile1 from '@/common/assets/images/ManageProfile1.svg';
import ManageSettings1 from '@/common/assets/images/ManageSettings1.svg';
import logoutIcon1 from '@/common/assets/images/Logout1.svg';
import styles from './index.module.less';
import footerLogo from '@/common/assets/images/footerImg.png';
import NotificationComponent from '@/pages/SocketFiles/componenets/NotificationSystem';
import { IoMdMenu, IoMdClose } from 'react-icons/io';
import ChatComponent from 'pages/ChatNowComponent/components/ChatSystem';
// import { FaChevronUp, FaChevronDown } from 'react-icons/fa';
import { FaChevronUp } from 'react-icons/fa';
// import messageIcon from '@/common/assets/images/messageIcon.svg';
// import ChatBotComponent from '@/common/Layout/ChatBotComponent';

// import {
//   LineChart,
//   Line,
//   XAxis,
//   YAxis,
//   Tooltip,
//   ResponsiveContainer
// } from 'recharts';

// const chartData = [
//   { name: 'One', value: 515 },
//   { name: 'Two', value: 100 },
//   { name: 'Three', value: 600 },
//   { name: 'Four', value: 50 }
// ];

// const thisWeekValue = 50;
// const totalValue = 1265;

// const CustomTooltip = ({ active, payload }) => {
//   if (active && payload && payload.length) {
//     const { name, value } = payload[0].payload;

//     return (
//       <div
//         style={{
//           backgroundColor: '#fff',
//           padding: '4px 8px',
//           border: '1px solid #ccc',
//           borderRadius: '4px',
//           fontSize: '12px',
//           color: '#D20B0B',
//           fontWeight: 'bold'
//         }}
//       >
//         {name}: {value}
//       </div>
//     );
//   }
//   return null;
// };
// console.log('chartData', chartData);
// export const DynamicGraph = () => {
//   return (
//     <div
//       style={{
//         display: 'flex',
//         alignItems: 'center',
//         background: 'linear-gradient(to right, #e74c3c, #f39c12)',
//         borderRadius: '12px',
//         padding: '10px 20px',
//         color: '#fff',
//         justifyContent: 'space-between'
//       }}
//     >
//       {/* LEFT: THIS WEEK */}
//       <div>
//         <p
//           style={{ marginTop: '15px', fontSize: '12px', whiteSpace: 'nowrap' }}
//         >
//           THIS WEEK
//         </p>
//         <p style={{ marginTop: '20px', fontSize: '20px', fontWeight: 'bold' }}>
//           {thisWeekValue}
//         </p>
//       </div>

//       {/* CENTER: CHART */}
//       <div style={{ width: '50%', height: 100 }}>
//         <ResponsiveContainer width="100%" height="100%">
//           <LineChart data={chartData}>
//             <Line
//               type="linear"
//               dataKey="value"
//               stroke="#faf1d9"
//               strokeWidth={2}
//               dot={{
//                 stroke: '#faf1d9',
//                 strokeWidth: 1,
//                 fill: '#faf1d9',
//                 r: 4
//               }}
//             />
//             <XAxis dataKey="name" />
//             <YAxis hide />
//             <Tooltip content={<CustomTooltip />} />
//           </LineChart>
//         </ResponsiveContainer>
//       </div>

//       {/* RIGHT: TOTAL */}
//       <div>
//         <p style={{ marginTop: '15px', fontSize: '12px' }}>TOTAL</p>
//         <p style={{ marginTop: '20px', fontSize: '20px', fontWeight: 'bold' }}>
//           {totalValue}
//         </p>
//       </div>
//     </div>
//   );
// };

// Second Code Snippet
// const getCurrentWeekOfMonth = () => {
//   const now = new Date();
//   const firstDay = new Date(now.getFullYear(), now.getMonth(), 1);
//   const dayOfMonth = now.getDate();
//   const adjustedDay = dayOfMonth + firstDay.getDay(); // handle week starts
//   return Math.ceil(adjustedDay / 7); // 1 to 5
// };

// // Function to get dynamic chart data based on current week
// const generateChartData = () => {
//   const currentWeek = getCurrentWeekOfMonth();

//   // You can replace these values with real data later
//   const fullMonthData = [
//     { name: 'Week 1', value: 110 },
//     { name: 'Week 2', value: 240 },
//     { name: 'Week 3', value: 360 },
//     { name: 'Week 4', value: 480 }
//   ];

//   return fullMonthData.slice(0, currentWeek);
// };

// export const DynamicGraph = () => {
//   const chartData = generateChartData();
//   console.log('chartData', chartData);
//   const isSinglePoint = chartData.length === 1;
//   console.log('isSinglePoint', isSinglePoint);
//   return (
//     <div
//       style={{
//         display: 'flex',
//         alignItems: 'center',
//         background: 'linear-gradient(to right, #e74c3c, #f39c12)',
//         borderRadius: '12px',
//         padding: '10px 20px',
//         color: '#fff',
//         justifyContent: 'space-between'
//       }}
//     >
//       {/* LEFT: THIS WEEK */}
//       <div>
//         <p
//           style={{
//             marginTop: '15px',
//             fontSize: '12px',
//             whiteSpace: 'nowrap',
//             paddingRight: '10px'
//           }}
//         >
//           THIS WEEK
//         </p>
//         <p style={{ marginTop: '20px', fontSize: '20px', fontWeight: 'bold' }}>
//           {chartData[chartData.length - 1]?.value ?? 0}
//         </p>
//       </div>

//       {/* CENTER: CHART */}
//       <div style={{ width: '50%', height: 50 }}>
//         <ResponsiveContainer width="100%" height={100}>
//           <LineChart data={chartData}>
//             <Line
//               type="linear"
//               dataKey="value"
//               stroke="#faf1d9"
//               strokeWidth={2}
//               dot={true}
//               // dot={{
//               //   stroke: '#faf1d9',
//               //   strokeWidth: 1,
//               //   fill: '#faf1d9',
//               //   r: 2
//               // }}
//               isAnimationActive={false}
//             />
//             {isSinglePoint && <circle cx="50%" cy="50%" r={5} fill="#faf1d9" />}
//             <XAxis dataKey="name" />
//             <YAxis />
//             <Tooltip content={<CustomTooltip />} />
//           </LineChart>
//         </ResponsiveContainer>
//       </div>

//       {/* RIGHT: TOTAL */}
//       <div>
//         <p style={{ marginTop: '15px', fontSize: '12px' }}>TOTAL</p>
//         <p style={{ marginTop: '20px', fontSize: '20px', fontWeight: 'bold' }}>
//           {chartData.reduce((acc, curr) => acc + curr.value, 0)}
//         </p>
//       </div>
//     </div>
//   );
// };

const { Content, Footer, Header } = Layout;
// Header, Sider,
const CommonLayout = ({ children, hideHeader = false }) => {
  const [isDropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);
  const dispatch = useDispatch();
  const [hover, setHover] = useState(false);
  const [openChat, setOpenChat] = useState(false);
  const navigate = useNavigate();
  // const [isBoxOpen, setIsBoxOpen] = useState(false);
  const [isTextVisible, setIsTextVisible] = useState(false);
  const toggleText = () => {
    setIsTextVisible(!isTextVisible);
  };
  const { user_payment_data, user_profile_data } = useSelector(
    (state) => state.listDashboard
  );
  // const { notifications } = useSelector((state) => state.login);
  // console.log('notifications', notifications);
  // const [isOpen, setIsOpen] = useState(false);

  // const toggleNotifications = () => {
  //   setIsOpen(!isOpen);
  // };
  // const user_data = user_payment_data;
  console.log('user_payment_data', user_profile_data?.profile_image);
  const toggleDropdown = () => {
    setDropdownOpen(!isDropdownOpen);
  };

  //  useEffect(() => {
  //     get_userPayment_id();
  //   }, []);

  //     const get_userPayment_id = () => {
  //       dispatch(get_Payment_ID());
  //     };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleRedirect = () => {
    navigate('/search');
  };

  const handleManageProfile = () => {
    navigate('/manageProfile');
  };

  const handleNavigate = () => {
    navigate('/dashboard');
  };

  const handleeeNavigateee = () => {
    navigate('/welcome');
  };

  const handleManageSettings = () => {
    navigate('/settings');
  };

  const handleLogout = () => {
    const accessToken = JSON.parse(
      localStorage.getItem('MAT-User')
    )?.accessToken;

    let payload = {
      token: accessToken
    };
    console.log('payload', payload);
    dispatch(logout());
  };

  useEffect(() => {
    get_userPayment_id();
  }, [useLocation().pathname]);

  const get_listby_id = () => {
    dispatch(get_byID());
  };

  const get_userPayment_id = () => {
    dispatch(get_Payment_ID());
  };

  useEffect(() => {
    get_listby_id();
    get_userPayment_id();
  }, []);

  // useEffect(() => {
  //   dispatch(get_notifications());
  // }, []);

  const matUserData = localStorage?.getItem('MAT-User');
  const matUserObject = JSON?.parse(matUserData);
  const profile_unique_id = matUserObject?.user_details?.profile_unique_id;
  // const profile_icon = matUserObject?.user_details?.profile_image;
  const profile_icon = user_profile_data?.profile_image;
  // const userId = matUserObject?.user_details?.id;
  console.log('MAT-User', profile_icon);

  // console.log('user_data', user_data);
  // const notifications_length = notifications?.length;

  return (
    <Layout className={styles.siderdev1}>
      <Layout>
        {/* Header */}
        {!hideHeader && (
          <Header className={styles.header}>
            {/* Left Menu */}
            <div className={styles.headerContainer}>
              <div className={styles.navbar}>
                {/* Left Side - Navigation Links */}
                <div className={styles.navLinks}>
                  {/* <span className={styles.navItem}>Home</span> */}
                  <Link to="/dashboard" className={styles.navItem}>
                    <img src={HomeIcon} alt="Home" />
                    Home
                  </Link>
                  {/* <span className={styles.separator}>|</span>
                  <span className={styles.navItem}>Membership</span> */}

                  {/* Using Code */}
                  <span className={styles.separator}>|</span>
                  <Link to="/helpcenter" className={styles.navItem}>
                    <img src={HelpCenterIcon} alt="Help Center" />
                    Help Center
                  </Link>
                  <span className={styles.separator}>|</span>
                  <Link to="/feedback" className={styles.navItem}>
                    <img src={FeedbackIcon} alt="Feedback" />
                    Feedback
                  </Link>

                  {/* <div className={styles.middleSection}>
                    <div className={styles.middleTop}>
                      <div className={styles.middleL}>THIS WEEK</div>
                      <div className={styles.middleL2}>{thisWeekValue}</div>
                    </div> */}

                  {/* <div className={styles.middleSection}>
                    <DynamicGraph />
                  </div> */}

                  {/* <div className={styles.middleTop}>
                      <span className={styles.middleL}>TOTAL</span>
                      <span className={styles.middleL2}>{totalValue}</span>
                    </div>
                  </div> */}
                </div>

                {/* Right Side - Icons & Profile */}
                <div className={styles.rightSection}>
                  {/* {user_data?.is_subscribed ? ( */}
                  {user_payment_data ? (
                    <>
                      <div className={styles.imgtxt} onClick={handleRedirect}>
                        <span className={styles.icons}>
                          <img src={SearchIcon} alt="Settings" />
                        </span>
                        <span className={styles.navItem1}>Search</span>
                      </div>
                      <span className={styles.separator}>|</span>
                    </>
                  ) : (
                    ''
                  )}

                  {/* <div className={styles.imgtxt}>
                    <span className={styles.navItem}>
                      <img src={NotificationIcon} alt="Notification" />
                      Notification
                    </span>
                    <span className={styles.separator}>|</span>
                  </div> */}
                  <div className={styles.imgtxt}>
                    {/* <span className={styles.navItem}> */}
                    {/* Wrap the notification component with your existing styles */}
                    <div className={styles.notificationWrapper}>
                      <NotificationComponent />
                    </div>
                    {/* </span> */}
                    {/* <span className={styles.separator}>|</span>  */}
                  </div>
                  <span className={styles.separator}>|</span>
                  {/* Profile Icon */}
                  <div className={styles.profileContainer} ref={dropdownRef}>
                    <div className={styles.profile} onClick={toggleDropdown}>
                      <img
                        // src={UserIcon}
                        src={
                          profile_icon && profile_icon.length > 0
                            ? profile_icon[0].objectKey
                            : UserIcon
                        }
                        alt="User"
                        // className={styles.userIcon}
                        className={
                          profile_icon && profile_icon.length > 0
                            ? styles.userIcon
                            : styles.defaultUserIcon
                        }
                      />
                      <p className={styles.uuidstyles}> {profile_unique_id} </p>
                      <span className={styles.arrowIcon}>
                        {isDropdownOpen ? '▲' : '▼'}
                      </span>
                    </div>

                    {isDropdownOpen && (
                      <div className={styles.dropdownMenu}>
                        <div
                          className={styles.dropdownItem}
                          onClick={handleManageProfile}
                          onMouseEnter={() => setHover('profile')}
                          onMouseLeave={() => setHover(null)}
                        >
                          <img
                            src={
                              hover === 'profile'
                                ? ManageProfile1
                                : ManageProfile
                            }
                            alt="profile"
                            style={{ paddingRight: '10px' }}
                            className={styles.ManageIcon}
                          />
                          Manage Profile
                        </div>
                        {/* Settings */}
                        <div
                          className={styles.dropdownItem}
                          onClick={handleManageSettings}
                          onMouseEnter={() => setHover('settings')}
                          onMouseLeave={() => setHover(null)}
                        >
                          <img
                            src={
                              hover === 'settings'
                                ? ManageSettings1
                                : ManageSettings
                            }
                            alt="settings"
                            style={{ paddingRight: '10px' }}
                            className={styles.ManageIcon}
                          />
                          Manage Settings
                        </div>

                        <div
                          className={styles.dropdownItem}
                          onClick={handleLogout}
                          onMouseEnter={() => setHover('logout')}
                          onMouseLeave={() => setHover(null)}
                        >
                          <img
                            src={hover === 'logout' ? logoutIcon1 : logoutIcon}
                            alt="logout"
                            style={{ paddingRight: '10px' }}
                            className={styles.ManageIcon}
                          />
                          Log Out
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div className={styles.headerContainerM}>
              {isTextVisible ? (
                <div className={styles.navbarM}>
                  {/* Profile Icon (Moved to Top) */}
                  <div className={styles.profileContainer} ref={dropdownRef}>
                    <div className={styles.profile} onClick={toggleDropdown}>
                      <img
                        src={UserIcon}
                        alt="User"
                        className={styles.userIcon}
                      />
                      <p className={styles.uuidstyles}>{profile_unique_id}</p>
                      <span className={styles.arrowIcon}>
                        {isDropdownOpen ? '▲' : '▼'}
                      </span>
                    </div>
                    {isDropdownOpen && (
                      <div className={styles.dropdownMenu}>
                        <div
                          className={styles.dropdownItem}
                          onClick={handleManageProfile}
                          onMouseEnter={() => setHover('profile')}
                          onMouseLeave={() => setHover(null)}
                        >
                          <img
                            src={
                              hover === 'profile'
                                ? ManageProfile1
                                : ManageProfile
                            }
                            alt="profile"
                            style={{ paddingRight: '10px' }}
                            className={styles.ManageIcon}
                          />
                          Manage Profile
                        </div>
                        <div
                          className={styles.dropdownItem}
                          onClick={handleLogout}
                          onMouseEnter={() => setHover('logout')}
                          onMouseLeave={() => setHover(null)}
                        >
                          <img
                            src={hover === 'logout' ? logoutIcon1 : logoutIcon}
                            alt="logout"
                            style={{ paddingRight: '10px' }}
                            className={styles.ManageIcon}
                          />
                          Log Out
                        </div>
                      </div>
                    )}
                  </div>

                  {/* Navigation Links */}
                  <Link to="/dashboard" className={styles.navItem}>
                    <img src={HomeIcon} alt="Home" />
                    Home
                  </Link>
                  <Link to="/helpcenter" className={styles.navItem}>
                    <img src={HelpCenterIcon} alt="Help Center" />
                    Help Center
                  </Link>
                  <Link to="/feedback" className={styles.navItem}>
                    <img src={FeedbackIcon} alt="Feedback" />
                    Feedback
                  </Link>

                  {/* Search (Only for subscribed users) */}
                  {user_payment_data ? (
                    <>
                      <div className={styles.imgtxt} onClick={handleRedirect}>
                        <span className={styles.icons}>
                          <img src={SearchIcon} alt="Search" />
                        </span>
                        <span className={styles.navItem1}>Search</span>
                      </div>
                      {/* <span className={styles.separator}>|</span> */}
                      {/* <div className={styles.imgtxt}>
                        <span className={styles.navItem}>
                         
                          <div className={styles.notificationWrapper}>
                            <NotificationComponent />
                          </div>
                        </span>
                       
                      </div> */}
                      <div className={styles.imgtxt}>
                        {/* <span className={styles.navItem}> */}
                        {/* Wrap the notification component with your existing styles */}
                        <div className={styles.notificationWrapper}>
                          <NotificationComponent />
                        </div>
                        {/* </span> */}
                        {/* <span className={styles.separator}>|</span>  */}
                      </div>
                    </>
                  ) : null}

                  {/* Close Button */}
                  <IoMdClose
                    onClick={toggleText}
                    className={styles.closeIcon}
                  />
                </div>
              ) : (
                // Menu Icon (when home is not visible)
                <IoMdMenu onClick={toggleText} className={styles.menuIcon} />
              )}
            </div>
            {/* Matrimony Logo on the Right */}
            <div className={styles.logoContainer}>
              <button
                onClick={handleNavigate}
                style={{
                  border: 'none',
                  background: 'transparent',
                  padding: 0,
                  cursor: 'pointer'
                }}
              >
                <img
                  src={matrimonyLogo}
                  alt="Matrimony Logo"
                  className={styles.logo}
                />
              </button>
            </div>
          </Header>
        )}

        {/* Main Content */}
        <Content className="p-6 bg-gray-50">
          {children}

          {user_payment_data && (
            <>
              <div className={styles.cOut}>
                <div className={styles.cIn} onClick={() => setOpenChat(true)}>
                  <div className={styles.ct}>Conversations</div>
                  <div className={styles.cb}>
                    <FaChevronUp onClick={() => setOpenChat(true)} />
                  </div>
                </div>
              </div>

              {openChat && (
                <ChatComponent
                  closeChat={() => setOpenChat(false)}
                  oChat={() => setOpenChat(true)}
                />
              )}
            </>
          )}
        </Content>

        {!openChat && (
          <Footer className={styles.footer}>
            {/* © Your Company Name. All rights reserved. */}
            {/* {!hideHeader && (
            <>
              <div
                className={styles.messageBox}
                onClick={() => setIsBoxOpen(true)} // Always set to true when clicked
              >
                <img src={messageIcon} alt="message Icon" />
              </div>
              {isBoxOpen && (
                <div className={styles.messageContent}>
                  <div className={styles.closeI}></div>
                  Pass isBoxOpen and setIsBoxOpen as props
                  <ChatBotComponent
                    isBoxOpen={isBoxOpen}
                    setIsBoxOpen={setIsBoxOpen}
                  />
                </div>
              )}
            </>
          )} */}

            {/* Above Chat Bot Code */}
            <div className={styles.container}>
              <div className={styles.logoSection}>
                <div className={styles.logoText}>
                  <button
                    // onClick={handleNavigate}
                    onClick={
                      profile_unique_id ? handleNavigate : handleeeNavigateee
                    }
                    style={{
                      border: 'none',
                      background: 'transparent',
                      padding: 0,
                      cursor: 'pointer'
                    }}
                  >
                    <img src={footerLogo} />
                  </button>
                </div>
              </div>

              <div className={styles.links_container}>
                {/* First Group */}
                <div className={styles.link_group}>
                  {/* <a href="/membership_list">Membership</a> */}
                  <a
                    href={
                      profile_unique_id ? '/membership_list' : '/membership'
                    }
                  >
                    Membership
                  </a>
                  {/* <a href="/faqs">FAQs</a> */}
                  <a href={profile_unique_id ? '/faqs' : '/welcome/faqs'}>
                    FAQs
                  </a>
                </div>

                {/* Second Group */}
                <div className={styles.link_group}>
                  <a href="/privacy-policy">Privacy Policy</a>
                  <a href="/terms-and-conditions">Terms & Conditions</a>
                  {/* <a href="#">Customer Care</a>
                <a href="#">Report Misuse</a> */}
                </div>

                {/* Third Group */}
                <div className={styles.link_group}>
                  {/* <a href="#">Privacy Policy</a> */}
                  <a href="/cookie-policy">Cookie Policy</a>
                  <a href="/policy-on-cancellations">
                    Cancellation/Refund Policy{' '}
                  </a>
                </div>
                {/* Fourth Group */}
                {/* <div className={styles.link_group}>
                <a href="/policy-on-cancellations">Cancellation Policy</a>
              </div> */}
              </div>

              {/* Social Media Icons */}
              <div className={styles.socialSection}>
                {/* <div className={styles.icon}>
                <Twitter />
                <img src={Twitter} />
              </div> */}
                <div className={styles.icon}>
                  {/* <Facebook /> */}
                  {/* <img src={Facebook} /> */}
                  <a
                    href="https://www.facebook.com/profile.php?id=61575095678281"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img src={Facebook} alt="Facebook" />
                  </a>
                </div>
                {/* <div className={styles.icon}> */}
                {/* <Instagram /> */}
                {/* <img src={Instagram} />
              </div> */}
                <div className={styles.icon}>
                  <a
                    href="https://www.instagram.com/elite_samskruti_matrimony/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img src={Instagram} alt="Instagram" />
                  </a>
                </div>
                {/* <div className={styles.icon}>
                <Linkedin />
                <img src={Linkedin} />
              </div> */}
              </div>
            </div>
          </Footer>
        )}
      </Layout>
    </Layout>
  );
};

export default CommonLayout;
